import { useQuery } from 'react-query'
import { api } from '../../api'
import { localConfig } from '../../../Configs/localConfig'
import { errorAlert } from '../../../utils/alert'

type Doses = {
  cod: number
  cod_cultura: number
  cod_aditivo: number
  dose: string
  cod_tipo_medida: number
  aditivo_nome: string
  cultura_nome: string
  tipo_medida_nome: string
}

export interface ItensAditivos {
  cod: number
  cod_conta: number
  cod_cliente: null
  cod_categoria_produto: number
  cod_fabricante: number
  nome: string
  descricao: string
  cod_formulacao: null
  adjuvante: number
  cod_tipo_adjuvante: null
  tipo_aditivo: number
  tipo_aditivo_nome: string
  observacao: string
  cod_medida_aplicacao: null
  cod_classe_agronomica: null
  cod_replica: null
  cod_variedade_hibrido: null
  cod_fertilizante: null
  cod_tecnologia: null
  acao_ph_calda: null
  cod_fornecedor: null
  tipo_formulacao: number
  fabricante_nome: string
  categoria_produto_nome: string
  classe_agronomica_nome: null
  nome_medida_aplicacao: null
  fornecedor_nome: null
  fertilizante: []
  doses: Doses[]
}

interface Aditivos {
  itens: ItensAditivos[]
  total: number
}

export const useGetAditivos = (pagination = 15, page = 1, nome?: string) => {

  const { conta, codCliente } = localConfig();
  const isCliente = localStorage.getItem('cod-cliente') !== '' && localStorage.getItem('cod-cliente') !== undefined
  const paramCliente = (isCliente && codCliente) ? `&codCliente=${codCliente}` : '';

  const queryKey: any = [`/recomendacao/aditivo`, conta, codCliente, page, pagination, nome]

  const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<Aditivos, Error>(
    queryKey,
    async () => {
      return api
        .get(
          `/recomendacao/aditivo?codConta=${conta}&pagination=${pagination}&page=${page}&embed=aditivo&nome=${nome}${paramCliente}`
        )
        .then((response): any => {
          return response.data
        })
        .catch((error) => {
          errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista de adjuvantes!')
        })
    },
    {
      enabled: false,
      refetchOnWindowFocus: false,
    }
  )

  return {
    data_aditivos: data,
    carregando_aditivos: isFetching,
    refetch_data_aditivos: refetch,
    isFetched: isFetchedAfterMount,
    isError: isError,
  }
}
